import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { checkUser } from '../../api/AuthAPI.js';

const AuthContext = React.createContext(null);

const AuthProvider = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refreshUser = () => {
    setLoading(true);
    checkUser()
      .then(setUser)
      .catch(console.error)
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    console.log('AuthProvider mounted');
    refreshUser();
  }, [location]);

  useEffect(() => {
    if (loading || !user) return;

    const isOnRegisterPage = location.pathname === '/register';

    if (!user.isConfirmed && !isOnRegisterPage) {
      const oauthProvider = user.googleId
        ? 'google'
        : user.facebookId
          ? 'facebook'
          : null;
      if (oauthProvider) {
        navigate(`/register?oauth=${oauthProvider}`, { replace: true });
      }
    }
  }, [user, loading, location.pathname, navigate]);

  return (
    <AuthContext.Provider value={{ user, setUser, loading }}>
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (ctx == null)
    throw new Error('useAuth must be used within <AuthProvider>.');
  return ctx;
};
